import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
  getByLocationDatetime,
} from '@/api/mileagestatisticsanalysisresultserv'

export default {
  state: {
    state_MileageStatisticsAnalysisResult_GetPageResult: null,
    state_MileageStatisticsAnalysisResult_GetDetailResult: null,
    state_MileageStatisticsAnalysisResult_GetClientPageResult: null,
    state_MileageStatisticsAnalysisResult_ExportExcelResult: null,
    state_MileageStatisticsAnalysisResult_GetByLocationDatetimeResult: null,
  },
  mutations: {
    SET_MILEAGESTATISTICSANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_MileageStatisticsAnalysisResult_GetPageResult = rst;
    },
    SET_MILEAGESTATISTICSANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_MileageStatisticsAnalysisResult_GetDetailResult = rst;
    },
    SET_MILEAGESTATISTICSANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_MileageStatisticsAnalysisResult_GetClientPageResult = rst;
    },
    SET_MILEAGESTATISTICSANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_MileageStatisticsAnalysisResult_ExportExcelResult = rst;
    },
    SET_MILEAGESTATISTICSANALYSISRESULT_GETBYLOCATIONDATETIME_RESULT: (state, rst) => {
      state.state_MileageStatisticsAnalysisResult_GetByLocationDatetimeResult = rst;
    },
  },
  actions: {
    MileageStatisticsAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MileageStatisticsAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MileageStatisticsAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MileageStatisticsAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MileageStatisticsAnalysisResultServ_GetByLocationDatetime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getByLocationDatetime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETBYLOCATIONDATETIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MILEAGESTATISTICSANALYSISRESULT_GETBYLOCATIONDATETIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_MileageStatisticsAnalysisResult_GetPageResult: state => {
      return state.state_MileageStatisticsAnalysisResult_GetPageResult;
    },
    get_MileageStatisticsAnalysisResult_GetDetailResult: state => {
      return state.state_MileageStatisticsAnalysisResult_GetDetailResult;
    },
    get_MileageStatisticsAnalysisResult_GetClientPageResult: state => {
      return state.state_MileageStatisticsAnalysisResult_GetClientPageResult;
    },
    get_MileageStatisticsAnalysisResult_ExportExcelResult: state => {
      return state.state_MileageStatisticsAnalysisResult_ExportExcelResult;
    },
    get_MileageStatisticsAnalysisResult_GetByLocationDatetimeResult: state => {
      return state.state_MileageStatisticsAnalysisResult_GetByLocationDatetimeResult;
    },
  }
}